import {IAvgPriceVendorData, IBestItemsData, IFillRateData, IKeyIndicatorData, IKeyIndicatorSupplierData, IMarketShareData, IProfitabilityData, IPromoAnalysisData, IServiceLevelTableData, IStockRotationData} from "../../models/reports/insights.interface";

export interface IReportFillRateState {
  data: Array<IFillRateData>;
  isDataLoaded: boolean;
}

export interface IReportStockRotationState {
  data: Array<IStockRotationData>;
  isDataLoaded: boolean;

}

export interface IReportMarketShareState {
  data: Array<IMarketShareData>;
  isDataLoaded: boolean;
}

export interface IReportKeyIndicatorsState {
  data: Array<IKeyIndicatorData>;
  isDataLoaded: boolean;
}
export interface IReportProfitabilityState {
  data: Array<IProfitabilityData>;
  isDataLoaded: boolean;
}

export interface IReportPromoState {
  data: Array<IPromoAnalysisData>;
  isDataLoaded: boolean;
}

export interface IReportKeyIndicatorsSuppliersState {
  data: Array<IKeyIndicatorSupplierData>;
  isDataLoaded: boolean;
}
export interface IReportBestItemsState {
  data: Array<IBestItemsData>;
  isDataLoaded: boolean;
}

export interface IReportAvgPriceState {
  data: Array<IAvgPriceVendorData>;
  isDataLoaded: boolean;
}
export interface IReportServiceLevelState {
  data: Array<IServiceLevelTableData>;
  isDataLoaded: boolean;
}

export const initialReportFillRateState:IReportFillRateState = {
  data: [],
  isDataLoaded: false
};

export const initialReportStockRotationState:IReportStockRotationState = {
  data: [],
  isDataLoaded: false
};
export const initialReportMarketShareState:IReportMarketShareState = {
  data: [],
  isDataLoaded: false
};
export const initialReportKeyIndicatorsState:IReportKeyIndicatorsState = {
  data: [],
  isDataLoaded: false
};
export const initialReportProfitabilityState:IReportProfitabilityState = {
  data: [],
  isDataLoaded: false
};
export const initialReportPromoState:IReportPromoState = {
  data: [],
  isDataLoaded: false
};

export const initialReportKeyIndicatorsSuppliersState:IReportKeyIndicatorsSuppliersState = {
  data: [],
  isDataLoaded: false
};

export const initialReportBestItemsState:IReportBestItemsState = {
  data: [],
  isDataLoaded: false
};

export const initialReportAvgPriceState:IReportAvgPriceState = {
  data: [],
  isDataLoaded: false
};
export const initialReportServiceLevelState: IReportServiceLevelState = {
  data: [],
  isDataLoaded: false
};
